import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const anchorStyles = {
  topLeft: {
    top: 'calc(100% + 5px)',
    bottom: 'auto',
    left: '0px',
    right: 'auto',
  },
  top: {
    top: 'calc(100% + 5px)',
    bottom: 'auto',
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
  },
  topRight: {
    top: 'calc(100% + 5px)',
    bottom: 'auto',
    right: '0px',
    left: 'auto',
  },
  rightTop: {
    top: '5px',
    bottom: 'auto',
    right: 'calc(100% + 5px)',
    left: 'auto',
  },
  right: {
    top: '50%',
    bottom: 'auto',
    right: 'calc(100% + 5px)',
    left: 'auto',
    transform: 'translateY(-50%)',
  },
  rightBottom: {
    top: 'auto',
    bottom: '5px',
    right: 'calc(100% + 5px)',
    left: 'auto',
  },
  bottomLeft: {
    bottom: 'calc(100% + 5px)',
    top: 'auto',
    left: '0px',
    right: 'auto',
  },
  bottom: {
    bottom: 'calc(100% + 5px)',
    top: 'auto',
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
  },
  bottomRight: {
    bottom: 'calc(100% + 5px)',
    top: 'auto',
    right: '0px',
    left: 'auto',
  },
  leftBottom: {
    top: 'auto',
    bottom: '5px',
    left: 'calc(100% + 5px)',
    right: 'auto',
  },
  left: {
    top: '50%',
    bottom: 'auto',
    left: 'calc(100% + 5px)',
    right: 'auto',
    transform: 'translateY(-50%)',
  },
  leftTop: {
    top: '5px',
    bottom: 'auto',
    left: 'calc(100% + 5px)',
    right: 'auto',
  },
};

const Popup = forwardRef(({ show, children, anchor, ...props }, ref) => {
  return show ? (
    <Container
      anchor={anchor}
      ref={ref}
      position="absolute"
      width="auto"
      minWidth="100%"
      borderRadius="11px"
      top="100%"
      zIndex="9"
      marginTop={theme => theme.margin.small}
      backgroundColor={theme => theme.background.background100}
      boxShadow={theme => theme.shadow.popup}
      border={theme => `1px solid ${theme.border.border600}`}
      {...anchorStyles[anchor || 'top']}
      {...props}
    >
      {children}
    </Container>
  ) : null;
});

Popup.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  anchor: PropTypes.oneOf([
    'topLeft',
    'top',
    'topRight',
    'rightTop',
    'right',
    'rightBottom',
    'bottomLeft',
    'bottom',
    'bottomRight',
    'leftBottom',
    'left',
    'leftTop',
  ]),
};

Popup.defaultProps = {
  show: false,
  className: null,
  children: null,
  anchor: null,
};

export default Popup;
